import {useMutation, useQueryClient} from '@tanstack/react-query';
import contractUpdaters from '@/api/updaters/contracts';

function useCancelContract() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['contracts', 'cancel'],
    mutationFn: contractUpdaters.cancel,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useCancelContract;
